$(document).ready(function() {
	


});



/**
 * Jednostavna funkcija za mjerenje vremena izvrsavanja pojedinih funkcija
 * 
 * Koristenje:
 * d = new debug();
 * d.end(bool); 
 */
	debug = function(name) {
	    var e = 0, s = 0;
	    var title = name || false;
	    
	    var __construct = function() {
	        s = new Date().getTime();
	    }();
	    
	    this.end = function(print, xtra) {
	        e = new Date().getTime();
	        r = (e-s);
	        print = print || true; // po defaultu printamo razliku
	        extra = '';
	        if (typeof xtra == 'object')
	            extra = xtra.attr('id');
	            
	        if (print) 
	            if (title) {
	                console.log(title+': '+r+' ms (' + extra+')');
	            } else {
	                console.log('vrijeme: '+r+' ms');
	            }
	            
	        else
	            return r;
	    };
	};